import React from 'react';
import * as A from '../actions/emailActions';
import { Icon } from 'antd';
import moment from 'moment';

const init = {

    loadingMessageTypes: null,
    loadingEmail: null,
    messageTypes: [],
    emailList: [],
    searchingMessages: null, // Didn't want to break whatever other code uses this.
    searchingMessagesRequest: { // This is a more suitable design for my purposes.
        status: null,
        code: null,
        timestamp: null
    },
    email: null,
    pagination: {
        totalCount: null,
        pageSize: 10,
        pageNum: 1,
        paged: 1
    },
    values: null,
    emailPreview: {
        isLoading: false,
        inError: false,
        loadTime: moment.utc().unix(),
        emailPreviewStore: {}
    }
}

export default (state=init, action) => { switch(action.type) {
    default: return {...state};

    case A.CLEAR_SELECTED_EMAIL:
        return {...state, email: null };

    case A.LOAD_MESSAGE_TYPES_REQUEST:
        return {...state, loadingMessageTypes: true };

    case A.LOAD_MESSAGE_TYPES_SUCCESS:
        return {...state, messageTypes: action.payload, loadingMessageTypes: false };

    case A.LOAD_MESSAGE_TYPES_FAILURE:
        return {...state, loading: false };

    case A.SEARCH_MESSAGES_PENDING:
        return {...state,
            searchingMessages: true,
            searchingMessagesRequest: {...state.searchingMessagesRequest,
                status: 'pending'
            }
        };

    case A.SEARCH_MESSAGE_SUCCESS:
        return {...state,
            searchingMessages: false,
            emailList: action.payload,
            searchingMessagesRequest: {...state.searchingMessagesRequest,
                status: 'success',
                timestamp: moment.utc().unix()
            },
            pagination: { ...state.pagination,
                totalCount: action.meta.totalCount,
                paged: action.meta.paged
            },
        };

    case A.SEARCH_MESSAGE_FAILURE:
        return {...state,
            searchingMessages: false,
            searchingMessagesRequest: {...state.searchingMessagesRequest,
                status: 'failure',
                timestamp: moment.utc().unix()
            }
        };

    case A.SEARCH_MESSAGE_RESET:
        return {...state,
            searchingMessages: null,
            searchingMessagesRequest: {...init.searchingMessagesRequest}
        };

    case A.LOAD_EMAIL_REQUEST:
        return {...state,
            loadingEmail: 'pending',
            email: {...action.payload }
        };

    case A.LOAD_EMAIL_SUCCESS:
        return {...state, loadingEmail: 'success', email: {...state.email,
            ...action.payload
        }};

    case A.LOAD_EMAIL_FAILURE:
        return {...state, loadingEmail: 'failure', email: null };

    case A.RESET_LOAD_EMAIL_REQUEST:
        return {...state, loadingEmail: null };

    case A.LOAD_EMAIL_PREVIEW_REQUEST:
        return {...state, emailPreview: {...state.emailPreview,
            isLoading: true,
            inError: false,
            loadTime: undefined
        }};

    case A.LOAD_EMAIL_PREVIEW_SUCCESS:
        return {...state, emailPreview: {...state.emailPreview,
            isLoading: false,
            inError: false,
            loadTime: moment.utc().unix(),
            emailPreviewStore: action.payload
        }};

    case A.LOAD_EMAIL_PREVIEW_FAILURE:
        return {...state, emailPreview: {...state.emailPreview,
            isLoading: false,
            inError: true,
            loadTime: undefined
        }};
    case A.STORE_SEARCH_VALUES:
        return {...state, values: action.payload };
    case A.STORE_PAGINATION:
        return {...state, pagination: {
            ...state.pagination,
            pageSize: action.payload.pageSize,
            pageNum: action.payload.pageNum
        }};
    case A.SET_EMAIL_ID:
        return {...state, email: state.email != null ? {...state.email, emailId: action.payload } : state.email };
}}
